import { Skeleton } from '@7f-ui/components/skeleton/skeleton'

export function MerchantProfileLoading() {
  return (
    <div className="flex gap-4" aria-hidden>
      <Skeleton className="size-16 shrink-0 rounded-xl" />
      <div className="flex-1 space-y-3">
        <Skeleton className="h-5 w-40" />
        <Skeleton className="h-4 w-32" />
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-10/12" />
      </div>
    </div>
  )
}
